import { Injectable } from '@angular/core';
import { Currency } from '../../shared/models/currency';
import { StaticValuesUtils } from 'src/app/utils/static-values/static-values.utils';
import { SearchResponse } from 'src/app/shared/models/domain/search-response';
import { CookieService } from '@shopping-angular-components/common-library';
import { X_PREFERRED_CURRENCY_CODE_COOKIE } from 'src/app/utils/constants/constants';

@Injectable({
  providedIn: 'root',
})
export class CurrencyService {
  currencies: Currency[];
  selectedCurrency: Currency;

  constructor(private readonly cookieService: CookieService) {}

  public initCurrencies(currencies) {
    this.currencies = currencies;
  }

  public getSelectedCurrency(): Currency {
      return this.selectedCurrency;
  }

  public setSelectedCurrency() {
    this.selectedCurrency = this.currencies.find(currency => {
      return currency.selected;
    });
  }

  private getCurrencyFromCode(currencyCode: string) {
    return this.currencies.find(currency => {
      return currency.value === currencyCode;
    });
  }

  changeSelectedCurrency(currencyValue: string) {
    let previousCurrency = this.selectedCurrency;

    if (previousCurrency.value === currencyValue) {
      this.selectedCurrency = this.getCurrencyFromCode(currencyValue);
    } else {
      let currentCurrency = this.currencies.find((currency) => {
        return currency.value === currencyValue;
      });
      previousCurrency.selected = false;
      currentCurrency.selected = true;
      this.selectedCurrency = currentCurrency;
    }
  }

 changeSelectedCurrencyAndSaveSelection(currencyValue: string) {
   this.changeSelectedCurrency(currencyValue);
   this.saveUserSelection(currencyValue);
 }

  updateCurrenciesValue(response: SearchResponse): void {

    this.initCurrencies(response.currencies.values);
    this.setSelectedCurrency();

    response.currencies.values.forEach(ac => {
      const exists = StaticValuesUtils.getAvailableCurrencies().some(c => c.currencyCode === ac.value);

      if (!exists) {
        StaticValuesUtils.getAvailableCurrencies().push({
          currencyCode: ac.value,
          value: ac.symbol  
        });
      }
    });

  }

  private saveUserSelection(currencyValue: string): void {
      const expires = new Date();
      expires.setHours(expires.getHours() + 12);
      this.cookieService.set(X_PREFERRED_CURRENCY_CODE_COOKIE, currencyValue, expires, '/');
  }

}
